import { Badge } from '@/shared/ui/badge';
import { REFERRAL_STATUS, REWARD_STATUS, rejectReasonLabel } from '../model/referral-status';
import type { MgmRewardRow, ReferralStatus } from '../model/types';
import { REFERRAL_ICON, REWARD_ICON } from './status-icons';

export function ReferralStatusBadge({ status, rejectReason }: { status: ReferralStatus; rejectReason?: string | null }) {
  const meta = REFERRAL_STATUS[status];
  const Icon = REFERRAL_ICON[status];
  return (
    <Badge variant={meta.variant} title={status === 'rejected' ? rejectReasonLabel(rejectReason) : undefined}>
      <Icon className="size-3.5" /> {meta.label}
    </Badge>
  );
}

export function RewardBadge({ reward }: { reward: MgmRewardRow | null }) {
  if (!reward) return <span className="text-xs text-muted-foreground">—</span>;
  const meta = REWARD_STATUS[reward.status];
  const Icon = REWARD_ICON[reward.status];
  return (
    <div className="flex flex-col items-start gap-0.5">
      <Badge variant={meta.variant}>
        <Icon className="size-3.5" /> {meta.label}
      </Badge>
      <span className="text-xs tabular-nums text-muted-foreground">{reward.amountText}</span>
    </div>
  );
}
